import { Observable } from 'rxjs';

import { BaseWorkPackageDto } from '@api/backend-connector/models';
import {
  SmartPickerHandler,
  SmartPickerPage,
  defaultSmartPickerOptions,
} from 'src/app/components-form/smart-input-entity/smart-picker.handler';
import { WorkPackagesService } from 'src/app/services/work-package.service';

type WorkPackagePickerContext = { projectId?: string };

export class WorkPackagePickerHandler extends SmartPickerHandler<BaseWorkPackageDto> {
  constructor(
    private workPackagesService: WorkPackagesService,
    private context: WorkPackagePickerContext,
  ) {
    super({ ...defaultSmartPickerOptions, showClear: true });
  }

  override getItems(params: {
    offset?: number | undefined;
    limit?: number | undefined;
    query?: string;
    excludeIds: string[] | undefined;
  }): Observable<SmartPickerPage<BaseWorkPackageDto>> {
    return this.workPackagesService.listWorkPackages({
      projectId: this.context.projectId,
      query: params.query,
      offset: params.offset,
      limit: params.limit,
      sorting: ['-position'],
      // excludeIds: params.excludeIds,
    });
  }
}
